{
  "sign_in": "Sign in",
  "password": "Password",
  "username_email": "Username or e-mail",
  "username": "Username",
  "email": "E-mail",
  "reset_password": "Reset password",
  "forgot_password": "Forgot your password",
  "enter_password": "Enter your password",
  "enter_username_email": "Enter your username or e-mail",
  "enter_email": "Enter your e-mail",
  "enter_username": "Enter your username",
  "home": "Home",
  "system_settings": "Configuration",
  "app_settings": "App Settings",
  "reservation_modes": "Reservation Modes",
  "reservation_templates": "Reservation Templates",
  "types": "Types",
  "fields": "Fields",
  "member_types": "Member types",
  "relation_types": "Relation types",
  "availability_types": "Availability types",
  "field_relations": "Field Relations",
  "periods": "Periods",
  "system_preferences": "System Preferences",
  "maintenance": "Maintenance",
  "maintenance_management": "Maintenance Management",
  "organizations_users": "User Management",
  "api_services": "API and services",
  "object_settings": "Object settings",
  "organizations": "Organizations",
  "roles_permissions": "Roles and permissions",
  "user_manager": "Users",
  "auth_configs": "Auth configs",
  "services": "Services",
  "auto_engine_tokens": "Auto engine tokens",
  "object_manager": "Object manager",
  "system": "System",
  "reservation_mode": "Reservation Mode",
  "reservation_mode_sub_title": "Manage reservation modes",
  "reservation_template": "Reservation template",
  "type": "Type",
  "field": "Field",
  "member_relation_type": "Member relation type",
  "relation_type": "Relation type",
  "field_relation": "Field relation",
  "availability_type": "Availability type",
  "time_rule": "Time rule",
  "period": "Period",
  "object": "Object",
  "save_changes": "Save",
  "discard_changes": "Discard",
  "batch_operations": "Batch operations",
  "import_objects": "Import objects",
  "documentation": "Documentation",
  "general_settings": "General Settings",
  "language_preferences": "Language preferences",
  "connections": "Connections",
  "move_reservations": "Move reservations",
  "properties_subtypes": "Properties and subtypes",
  "organizations_templates": "Organizations and templates",
  "preferences": "Preferences",
  "references": "References",
  "configuration": "Configuration",
  "details": "Details",
  "templates": "Templates",
  "intervals_and_related_periods": "Intervals and related periods",
  "name": "Name",
  "description": "Description",
  "language": "Language",
  "alt_name": "Alt.name",
  "alt_description": "Alt.description",
  "show_in_client": "Show in client",
  "show_in_culling": "Show in culling",
  "list_by_name": "List by name",
  "list_by_extid": "List by ext.id",
  "member_relation_types": "Member relation types",
  "availability_relation_types": "Availability relation types",
  "availability_relation_type": "Availability relation type",
  "id": "Id",
  "ext_id": "Ext.id",
  "private_role": "Private role",
  "standard_organization": "Standard organization",
  "default_status": "Default status",
  "active": "Active",
  "auth_config_active": "Active login method",
  "affect_orders": "Affect orders",
  "delete_reservation_when_culling": "Delete reservation when culling",
  "properties": "Properties",
  "occurrence": "Occurrence",
  "members": "Members",
  "availability": "Availability",
  "special": "Special",
  "text": "Text",
  "result": "Result",
  "move_to": "Move to",
  "count": "Count",
  "from_date": "From date",
  "choose_type": "Choose type",
  "combinations": "Combinations",
  "sort": "Sort",
  "action": "Action",
  "yes": "Yes",
  "no": "No",
  "sure_to_delete": "Are you sure you want to delete this type?",
  "min_max": "Min/max",
  "reservation_kind": "Reservation kind",
  "ma_com_opt": "Ma. / Com. / Opt.",
  "obj_virt_inco": "Obj. / Virt. / Inco.",
  "member_type": "Member type",
  "request_type": "Request type",
  "canc_per": "Canc.per",
  "opt_rel": "Opt.rel",
  "auto_o": "Auto.o",
  "res_text": "Res.text",
  "obst_text": "Obst.text",
  "add_type": "Add type",
  "personal_data": "Personal data",
  "warning_not_delete_type_in_use": "WARNING! You can NOT delete a type that is in use!",
  "allow_standard_objects": "Allow standard objects",
  "allow_abstract_objects": "Allow abstract objects",
  "allow_virtual_objects": "Allow virtual objects",
  "person_type": "Person type",
  "location_type": "Location type",
  "alias_type": "Alias type",
  "external_ownership": "External ownership",
  "subtypes": "Subtypes",
  "parent_fields": "Parent fields",
  "field_type": "Field type",
  "sum_type": "Sum type",
  "top_level_type": "Top level type",
  "title_type": "Title type",
  "ref_separator": "Ref. separator",
  "searchable_in_reservation": "Searchable in reservation lists",
  "reservation_in_text_field": "Reservation in text field",
  "mandatory": "Mandatory",
  "unique": "Unique",
  "multiple": "Multiple",
  "editable": "Editable",
  "searchable": "Searchable",
  "listable": "Listable",
  "primary": "Primary",
  "sortable": "Sortable",
  "virtual_category": "Virtual category",
  "abstract_category": "Abstract category",
  "default_value": "Default value",
  "category": "Category",
  "add_category": "Add category",
  "exceeded_maximum_limit_categories": "You have exceeded the maximum limit of {0} categories.",
  "delete_type": "Delete type",
  "filter": "Filter",
  "categories": "Categories",
  "reference_fields": "Reference fields",
  "member_level": "Member level",
  "help_type": "Help type",
  "source_field": "Source field",
  "match_field": "Match field",
  "unvalid_combination_fields": "Invalid combination of fields",
  "additional configuration": "Additional configuration",
  "match_mode": "Match mode",
  "matchAll": "Match all",
  "matchOne": "Match one",
  "constitutes_obstacle": "Constitues obstacle",
  "occupied_by_default": "Occupied by default",
  "own_object": "Own object",
  "user_objects": "User objects",
  "standard": "Standard",
  "time": "Time",
  "hours": "Hours",
  "h_mm": "h:mm",
  "standard_step": "Standard step",
  "minimum_step": "Minimum step",
  "begin_step": "Begin time step",
  "import_step": "Import step",
  "minimum_length": "Minimum length",
  "maximum_length": "Maximum length",
  "default_length": "Default length",
  "minutes": "Minutes",
  "begin_offset": "Begin offset",
  "time_slots": "Time slots",
  "weekday_selection": "Weekday selection",
  "add_weekday_selection": "Add weekday selection",
  "delete_weekday_selection": "Delete weekday selection",
  "date": "Date",
  "relative_start_time": "Relative start time",
  "relative_end_time": "Relative end time",
  "use_start_time_to_open_next_day": "Use start time to open next day",
  "use_separate_cancellation_rules": "Use separate cancellation rules",
  "reservation_periods": "Reservation periods",
  "reservation_period": "Reservation period",
  "reservation_length": "Reservation length",
  "reservation_count": "Reservation count",
  "use_modified_by_when_calculating": "Use modified by when calculating user quota",
  "time_slot": "Time slot",
  "sure_to_delete_time_slot": "Are you sure you want to delete this time slot",
  "copy": "Copy",
  "ex_1_time_slots": "Ex.1: 8:00-17:15, 8:30-17, 9-17:15  (three slots)",
  "ex_2_time_slots": "Ex.2: 08:00-08:45x0:15-17:15 (repeat the slot 08:00-08:45 every 15 minutes until 17:15)",
  "property": "Property",
  "add_time_slot": "Add time slot(s)",
  "sure_to_delete_object": "Are you sure to delete this object",
  "actions": "Actions",
  "modification_history": "Modification history",
  "last_modified": "Last modified",
  "color": "Color",
  "add": "Add",
  "search": "Search",
  "signature": "Signature",
  "telephone": "Telephone",
  "comment": "Comment",
  "integer": "Integer",
  "length": "Length",
  "checkbox": "Checkbox",
  "reference": "Reference",
  "nonSearchableText": "Non searchable text",
  "nonSearchableReference": "Non searchable reference",
  "none": "-",
  "abstract": "Abstract",
  "physical": "Physical",
  "virtualStandard": "Virtual standard",
  "virtualAbstract": "Virtual abstract",
  "templateObject": "Template object",
  "default": "Default",
  "auth_config_default": "Default login method",
  "public": "Public",
  "limited": "Limited",
  "hidden": "Hidden",
  "PUBLIC": "Public",
  "LIMITED": "Limited",
  "date_time_intervals": "Date",
  "year": "Year",
  "week": "Week",
  "month": "Month",
  "day": "Day",
  "weekday": "Weekday",
  "useOnly": "Use only",
  "strict": "Strict",
  "dynamic": "Dynamic",
  "confirmed": "Confirmed",
  "confirm": "Confirm",
  "planned": "Planned",
  "preliminary": "Preliminary",
  "abstractDisplay": "Abstract display",
  "physicalDouble": "Physical double",
  "optionalDouble": "Optional double",
  "combination": "Combination",
  "optional": "Optional",
  "nonVirtualObjects": "Non virtual objects",
  "virtual": "Virtual",
  "incomplete": "Incomplete",
  "never": "Never",
  "always": "Always",
  "mon": "Mon",
  "tue": "Tue",
  "wed": "Wed",
  "thu": "Thu",
  "fri": "Fri",
  "sat": "Sat",
  "sun": "Sun",
  "no_weekday_selection": "No weekday selection",
  "copy_weekday_selection": "Copy weekday selection",
  "reservationPeriod": "Reservation period",
  "short": "Short",
  "user_access": "User access",
  "child_periods": "Child periods",
  "parent_periods": "Parent periods",
  "interval_type": "Interval type",
  "start": "Start",
  "end": "End",
  "sure_to_delete_period": "Are you sure to delete this period",
  "add_interval": "Add interval",
  "select_interval": "Select interval",
  "select_country": "Select country",
  "select_type": "Select type",
  "from": "From",
  "to": "To",
  "list_holidays": "List holidays",
  "create_holiday_reservations_from_selection": "Create holiday reservations from selection",
  "perform_maintenance": "Perform maintenance",
  "reset_database": "Reset database",
  "WARNING": "WARNING",
  "this_action_is_not_recommended": "this action is not recommended",
  "database_is_reseted": "Database is reseted",
  "sure_to_reset_database": "All reservations, cancellations, reservation history, reservation drafts, reservation registrations, orders and user sessions will be deleted. Are you sure",
  "there_is_no_way_to_recall_it": "There is no way to recall it",
  "successfully_performed_maintenance": "Successfully performed maintenance",
  "maintenance_performed_for": "Maintenance performed for",
  "maintenance_not_performed": "Maintenance not performed",
  "please_select_items_before_clicking_on": "Please select items before clicking on",
  "miscellaneous": "Miscellaneous",
  "select_action": "Select action",
  "value": "Value",
  "close_unused_sessions": "Close unused sessions",
  "general_description": "General description",
  "general_name": "General name",
  "general_email": "General e-mail",
  "general_phone": "General phone",
  "general_URL_title": "General URL title",
  "general_manual_title": "General manual title",
  "technical_description": "Technical description",
  "technical_name": "Technical name",
  "technical_email": "Technical e-mail",
  "technical_phone": "Technical phone",
  "technical_URL_title": "Technical URL title",
  "technical_manual_title": "Technical manual title",
  "email_settings": "E-mail settings",
  "email_max_members": "E-mail max members",
  "do_not_use_the_user_email_address_as": "Do not use the user e-mail address as",
  "set": "Set",
  "as": "as",
  "include_empty_reservation_fields_when_sending_email": "Include empty reservation fields when sending e-mail",
  "send_server_emails_to_Slack_for_debugging": "Send server e-mail to Slack for debugging",
  "preview_of_email_template": "Preview of e-mail template",
  "email_templates": "E-mail templates",
  "email_templates_setting": "E-mail templates setting",
  "email_type": "Email type",
  "template": "Template",
  "subject": "Subject",
  "message": "Message",
  "preview": "Preview",
  "variables_to_use_in_email": "Variables (to use in e-mail)",
  "active_features": "Active features",
  "customer_name": "Customer name",
  "calendar_background_text": "Calendar background text",
  "order_accept_span": "Order accept span",
  "allow_Java_client": "Allow Java client",
  "allow_double_booking_of_type_without_sufficient_permissions": "Allow double booking of type without sufficient permissions",
  "max_reservation_objects": "Max reservation objects",
  "max_import_field_values": "Max import field values",
  "optional_relations": "Optional relations",
  "make_optional_if_any_object_is_optional_on_multi_selection": "Make optional if any object is optional on multi selection",
  "reservation_exceptions": "Reservation exceptions",
  "hide_possibility_of_making_member_exceptions_on_reservations": "Hide possibility of making members exceptions on reservations",
  "reservationOrder_list": "Reservation/order list",
  "use_reserve_permisson_on_objects_in_list_when_modify_permission_is_used": "Use reserve permission on objects in list when modify permission is used",
  "reservation_permissions": "Reservation permissions",
  "allow_non_admin_users_to_change_reservation_organizations": "Allow non admin users to change reservation organizations",
  "allow_user_to_change": "Allow user to change \"affect_orders\" on template regardless of reservation count",
  "selected_list": "Selected list",
  "display_warning_when_an_object_is_unrelated": "Display warning when an object is unrelated",
  "passwords_and_authentication": "Passwords and authentication",
  "password_rules": "Password rules",
  "do_not_allow_passwords_containing_login_name": "Do not allow passwords containing login name",
  "do_not_allow_passwords_on_black_list": "Do not allow passwords on black list",
  "require_lower_case_character": "Require lower case character",
  "require_upper_case_character": "Require upper case character",
  "require_digit_character": "Require digit character",
  "require_special_character": "Require special character",
  "external_web_login_URL": "External web login URL",
  "user_object_patterns": "User object patterns",
  "user_settings": "User settings",
  "add_patterns": "Add patterns",
  "remove_patterns": "Remove patterns",
  "please_select_time_zones": "Please select time zones",
  "move_reservations_from": "Move reservations from",
  "move_reservations_between_time_zones": "Move reservations between time zones",
  "from_time_zone": "From time zone",
  "to_time_zone": "To time zone",
  "moving_reservations_from_time_zone": "Moving reservations from time zone",
  "external_permissions": "External permissions",
  "set_by": "Set by",
  "short_name": "Short name",
  "long_name": "Long name",
  "time_zone": "Time zone",
  "daylight_savings_time": "Daylight savings time",
  "offset": "Offset",
  "sure_to_delete_time_zone": "Are you sure to delete this time zone",
  "add_new_time_zone": "Add new time zone",
  "set_the_user_email_address_as": "Set the user e-mail address as",
  "reply_to": "reply to",
  "email_preferences": "E-mail preferences",
  "on_template_regardless_of_reservation_count": "on template regardless of reservation count",
  "information": "Information",
  "personal_information": "Personal information",
  "created": "Created",
  "expand_row": "Expand row",
  "collapse_row": "Collapse row",
  "created_by": "Created by",
  "relations": "Relations",
  "relations_subtitle": "Manage relation types",
  "availability_related": "Availability related",
  "optional_related": "Optional related",
  "edit": "Edit",
  "create": "Create",
  "set_daterange_on_member_relation": "Set daterange on member relation",
  "cancel": "Cancel",
  "sure_to_delete_type": "Are you sure to delete this type?",
  "delete": "Delete",
  "select_member_type": "Select member type",
  "set_daterange_on_relation_object": "Set daterange on relation object",
  "select_relation_type": "Select relation type",
  "delete_all": "Delete all",
  "not_active": "Not active",
  "de_activate": "Deactivate",
  "activate": "Activate",
  "add_member_object": "Add member object(s)",
  "save_added_member_object": "Save added member object(s)",
  "remove_member_object": "Remove member object(s)",
  "save_removed_member_object": "Save removed member object(s)",
  "add_relation_object": "Add relation object(s)",
  "save_added_relation_object": "Save added relation object(s)",
  "remove_relation_object": "Remove relation object(s)",
  "save_removed_relation_object": "Save removed relation object(s)",
  "add_organization": "Add organization(s)",
  "save_added_organization": "Save added organization(s)",
  "remove_organization": "Remove organization(s)",
  "save_removed_organization": "Save removed organization(s)",
  "add_availability_relation_object": "Add availability relations object(s)",
  "save_added_availability_relation_object": "Save added availability relations object(s)",
  "remove_availability_relation_object": "Remove availability relations object(s)",
  "save_removed_availability_relation_object": "Save removed availability relations object(s)",
  "add_optional_relation_object": "Add optional relation object(s)",
  "save_added_optional_relation_object": "Save added optional relation object(s)",
  "remove_optional_relation_object": "Remove optional relation object(s)",
  "save_removed_optional_relation_object": "Save removed optional relation object(s)",
  "columns": "Columns",
  "ok": "Ok",
  "select_all_fields": "Select all fields",
  "de_select_all_fields": "Deselect all fields",
  "field_values_not_possible_to_display_or_edit_if_the_selected_objects_have_different_types": "Field values are not possible to display or edit if the selected objects have different types",
  "extid_reservation_mode_already_exists": "It already exists a reservation mode with this ext.id. This reservation mode is not saved!",
  "extid_availability_type_already_exists": "It already exists an availability type with this ext.id. This availability type is not saved!",
  "name_field_relation_already_exists": "It already exists a field relation with this name. This field relation is not saved!",
  "extid_field_already_exists": "It already exists a field with this ext.id. This field is not saved!",
  "extid_type_already_exists": "It already exists a type with this ext.id. This type is not saved!",
  "extid_object_already_exists": "It already exists a object with this ext.id. This object is not saved!",
  "users": "Users",
  "organization_groups": "Organization groups",
  "integration": "Integration",
  "products": "Products",
  "access_tokens": "Access tokens",
  "backups": "Backups",
  "culling": "Culling",
  "reports": "Reports",
  "settings": "Settings",
  "views": "Views",
  "header_periods": "Header periods",
  "creator_user": "Creator user",
  "template_user": "Template user",
  "related_objects": "Related objects",
  "organization": "Organization",
  "parent_organization": "Parent organization",
  "roles": "Roles",
  "type_password_again": "type password again",
  "change_password": "Change password",
  "first_name": "First name",
  "last_name": "Last name",
  "owner": "Owner",
  "lock_user_for_external_authentication": "Lock user for external authentication",
  "allow_login": "Allow login",
  "super": "Super",
  "admin": "Admin",
  "vue_admin": "Vue admin",
  "client": "Client",
  "user_object": "User object",
  "object_permissions": "Object permissions",
  "clear": "Clear",
  "update": "Update",
  "reinit_services": "Reinit services",
  "server_type": "Server type",
  "date_format": "Date format",
  "permissions": "Permissions",
  "operator": "Operator",
  "country": "Country",
  "form.validation_error.email_pattern": "${label} needs to be a valid email",
  "form.validation_error.guid_pattern": "${label} needs to be a valid GUID",
  "form.validation_error.required": "${label} is required",
  "help_ext_id": "External id",
  "help_show_in_culling": "help_text_missing",
  "help_show_in_client": "help_text_missing",
  "help_sort_res_template_types": "help_text_missing",
  "help_type_res_template_types": "Type that occurs on the template",
  "help_action_res_template_types": "help_text_missing",
  "help_minmax_res_template_types": "Object count (exact count or min/max)",
  "help_reservation_kind_res_template_types": "help_text_missing",
  "help_ma_com_opt_res_template_types": "Mandatory: Mandatory type for all reservations of current template, can be excluded on an incomplete reservation.\nCombination: Part of some combinations that are set below.\nOptional: Optional for all reservations of current template, the type is always possible to select.",
  "help_obj_virt_inco_res_template_types": "Object: Non-virtual objects. A non-virtual object must be selected of the type.\nVirtual: All objects including virtual. Allow virtual object or other objects of the type.\nIncomplete: Allow incomplete. Allow a placeholder of the type.",
  "help_member_type_res_template_types": "If and how to use members",
  "help_availability_type_res_template_types": "If and how to use availability",
  "help_request_type_res_template_types": "Request type. The type to be requested instead of booked directly, for instance 'room'",
  "help_can_per_res_template_types": "Allow user to cancel reservation without reserve permission on this type",
  "help_opt_rel_res_template_types": "Optional relation, check the physical type that will be abstract.\nCould be used with optional courses, the physical group will be abstract (check the group)",
  "help_auto_o_res_template_types": "Automatic object selection, i.e. choose an available object (for example a room) that matches your search criteria",
  "help_res_text_res_template_types": "Set the reservation text mode (blue reservations)",
  "help_obst_text_res_template_types": "Set the obstacle text mode (yellow reservations)",
  "help_language_select": "help_text_missing",
  "help_language_alt_name": "help_text_missing",
  "help_language_alt_description": "help_text_missing",
  "help_filter_fields": "A filter to set which values can be entered on a text field",
  "help_length_fields": "The maximum length of text fields",
  "help_min_max_fields": "Minimum and maximum values for integer fields",
  "help_sum_type_fields": "This field automatically counts the number of members for the selected type",
  "help_top_level_type_fields": "This field will be shown as a category on this type and subtypes",
  "help_title_type_fields": "This type is used for reference when the field is displayed on the root type",
  "help_ref_separator_fields": "Separator used when concatenating values on a reference field",
  "help_mandatory_fields": "help_text_missing",
  "help_unique_fields": "help_text_missing",
  "help_multiple_fields": "help_text_missing",
  "help_editable_fields": "help_text_missing",
  "help_searchable_fields": "help_text_missing",
  "help_listable_fields": "help_text_missing",
  "help_primary_fields": "help_text_missing",
  "help_sortable_fields": "help_text_missing",
  "help_type_member_types": "Type to be used to define the member, i.e. the member relations should be created with objects of this type",
  "help_member_level_member_types": "Determines the member level of the type. The largest group is level 1, subgroups are level 2, etc.",
  "help_type_relation_type": "Type to be used to define the relation, i.e. the relations should be created with objects of this type",
  "help_help_type_relation_types": "A help type is only used when an object is related to a main type",
  "help_source_field_field_relations": "help_text_missing",
  "help_match_field_field_relations": "help_text_missing",
  "help_match_mode_field_relations": "help_text_missing",
  "help_operator_field_relations": "help_text_missing",
  "help_constitutes_obstacle_availability_types": "States if the availability can not be overbooked",
  "help_occupied_by_default_availability_types": "States if objects that misses availability relations should be occupied",
  "help_type_availability_types": "Type to be used to define the availability, i.e. the availability relations should be created with objects of this type",
  "help_own_object_availability_types": "Availability for own type. The type defines it owns availability",
  "help_user_objects_availability_types": "Availability for user objects. The objects are related to the user instead of the selected objects",
  "help_email_max_member_system_prefs": "Set the maximum number of members to send e-mail to",
  "help_do_not_use_the_user_email_address_as_system_prefs": "Use a generic no-reply address as \"from\"",
  "help_set_the_user_email_address_as_system_prefs": "Set if the user e-mail address should be used as the \"reply to\" address",
  "help_include_empty_reservation_fields_when_sending_email_system_prefs": "Add checkbox for empty reservation fields when sending reservation through e-mail",
  "help_send_server_emails_to_Slack_for_debugging_system_prefs": "Will send request, rejected and accepted e-mails to Slack #applikationsnotiser",
  "help_active_features_system_prefs": "help_text_missing",
  "help_customer_name_system_prefs": "help_text_missing",
  "help_order_accept_span_system_prefs": "The span which is acceptable to make an order fulfilled. May be between 1 and 200 percent.",
  "help_allow_java_client_system_prefs": "Allow users to use Java client calendar. Certain users may be excluded from this.",
  "help_allow_double_booking_of_type_system_prefs": "Select a type for which double booking without modify permission on other reservations is possible",
  "help_max_reservation_objects_system_prefs": "The maximum total number objects that can be reserved on a reservation",
  "help_max_import_field_values": "Set the maximum number of field values that can be imported to an object",
  "help_make_optional_if_any_object_is_optional_on_multi_selection_system_prefs": "help_text_missing",
  "help_hide_possibility_of_making_member_exceptions_on_reservations_system_prefs": "help_text_missing",
  "help_use_reserve_permisson_on_objects_in_list_when_modify_permission_is_used_system_prefs": "help_text_missing",
  "help_allow_non_admin_users_to_change_reservation_organizations_system_prefs": "help_text_missing",
  "help_allow_user_to_change_system_prefs": "help_text_missing",
  "help_display_warning_when_an_object_is_unrelated_system_prefs": "Show warning when a non related object is selected in the calendar selected list",
  "help_user_object_patterns_system_prefs": "Patterns to match objects from user in personal data report",
  "help_external_web_login_url_system_prefs": "help_text_missing",
  "help_move_reservation_system_prefs": "Move reservations",
  "help_external_permissions_system_prefs": "The external permissions that can be set on a user",
  "help_padding_res_template_type": "Time padding between on and between objects",
  "days": "Days",
  "extId": "Ext.id",
  "fieldOrder": "Field order",
  "modified": "Modified",
  "modified_by": "Modified by",
  "created_date": "Created (date)",
  "modified_date": "Modified (date)",
  "activate_deactivate": "Activate / Deactivate",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "show_all": "Show all",
  "filter_on_field_type": "Filter on field type",
  "integer_field": "Integer field",
  "text_field": "Text field",
  "category_field": "Category field",
  "checkbox_field": "Checkbox field",
  "allowed_relations": "Allowed relations",
  "add_new_interval": "Add new interval",
  "not_possible_to_add_an_interval_including_everything": "Not possible to save an interval including everything, that is not a period!",
  "listed_objects": "Listed objects",
  "add_object": "Add object",
  "show_all_actions": "Show all actions",
  "show_no_actions": "Show no actions",
  "system_information": "System information",
  "show_all_system_information": "Show all system information",
  "show_no_system_information": "Show no system information",
  "select": "Select",
  "client_id": "Client id",
  "repeat_password": "Repeat password",
  "use_token": "Use token",
  "last_used": "Last used",
  "repeated_password_should_match_with_password": "Repeated password should match with password",
  "api_authentication_tokens": "API Authentication tokens",
  "accepted": "Accepted",
  "reserved": "Reserved",
  "cancelled": "Cancelled",
  "requested": "Requested",
  "rejected": "Rejected",
  "low": "Low",
  "high": "High",
  "normal": "Normal",
  "extreme": "Extreme",
  "wild_thing": "Wild thing",
  "you_kidding": "You've got to be kidding me",
  "cancel requested": "Cancel requested",
  "help_short_interval": "Sets an extra short interval; 1 hour, instead of 5 hours",
  "inactive": "Inactive",
  "all": "All",
  "reservation": "Reservation",
  "infoReservation": "Info reservation",
  "reservationModeOrder": "Reservation mode order",
  "filter_on_root_periods": "Filter on root periods",
  "root_periods": "Root periods",
  "all_periods": "All periods",
  "show_hidden_periods": "Show hidden periods",
  "hide_hidden_periods": "Hide hidden periods",
  "hidden_periods": "Hidden periods",
  "filter_on_template_type": "Filter on template type",
  "sort_on": "Sort on",
  "filter_on_active": "Filter on active",
  "second_column": "Second column",
  "action_will_delete_information": "This action will delete all reservations, cancellations, reservation history, reservation drafts, reservation registrations, orders and user sessions.",
  "really_sure_to_reset_database": "Are your REALLY sure that you want to reset the database",
  "execute_reset_database": "Execute 'Reset database'",
  "help_auth_config_active": "Enable login method",
  "help_auth_config_default": "Set as a default login method",
  "log_level": "Log level",
  "help_log_level": "help_text_missing",
  "DEBUG": "DEBUG",
  "SIGN": "SIGN",
  "REQUIRED": "REQUIRED",
  "help_enabled_applications": "Enabled applications for this authentication configuration",
  "enabled_applications": "Enabled applications",
  "strategy": "Strategy",
  "help_auth_configs_strategy": "Strategy for authentication",
  "summary": "Summary",
  "help_auth_configs_summary": "help_text_missing",
  "use_MFA": "Use MFA",
  "help_use_mfa": "Use Multi-Factor-Authentication",
  "timeedit_entity_id_missing": "TimeEdit Entity Id is missing",
  "help_calendar_background_text": "help_text_missing",
  "idp_metadata_url": "IdP Metadata URL",
  "help_idp_metadata_url": "Metadata URL of the identity provider. The address of the identity provider metadata.",
  "idp_entity_id": "IdP Entity ID",
  "help_idp_entity_id": "Entity ID of the identity provider. The entity ID of the identity provider. If left blank, it is assumed to be the same as the \"IdP Metadata URL\".",
  "timeedit_entity_id": "TimeEdit Entity ID",
  "help_timeedit_entity_id": "Entity ID for this TimeEdit authentication server. Entity ID of the TimeEdit service. This id should be unique since it may occur in the same \"IdP Metadata URL\" as another \"TimeEdit Entity ID\". \nThe ID should only contain [a-zA-Z0-9_-.:/]. This may for instance be on the form \"timeedit.net/customer_signature\". If more than one configuration is used it may use the form \"timeedit.net/customer_signature/user_type\". REQUIRED",
  "idp_logout_url": "IdP Logout URL",
  "help_idp_logout_url": "The identity provider's logout endpoint (its SAML Single Logout Service). TimeEdit needs it to complete SAML logout in both directions: it sends its logout request here when TimeEdit initiates logout, and its response here when your identity provider initiates logout. Recommended: always populate it via autofill from the IdP metadata whenever your IdP has one; you can also set it manually to override.",
  "idp_entry_point_url": "IdP Entry Point URL",
  "help_idp_entry_point_url": "help_text_missing",
  "idp_public_key": "IdP Public Key",
  "help_idp_public_key": "help_text_missing",
  "signature_signing": "Signature signing",
  "help_signature_signing": "Use signatures. Sign messages and verify signatures. \nThis option turns on signing of SSO requests. By default it uses embedded signing of the XML. \nTo require signing of responses, use below option \"Require signatures\". \nIt can also be completed using \"Use dynamic signatures\"  in which case signing may be performed in a different manner.\nAll signing should not be turned off other than for testing purposes.\nBy default this option is enabled. Use dynamic signatures.\nSign and verify messages dynamically depending on the message method.\nEnabling this checkbox makes the signing method dependent on the message binding. If the message binding is a HTTP-Redirect () it uses URL signing. If the message binding is a HTTP-POST it uses signing embedded in the XML. This is an advantage if the redirects need to have a limited size since it will make the redirect URL shorter or use POST binding if messages are larger.\nEnabling this option may change how messages are signed.\nBy default this option is not enabled.",
  "signature_algorithm": "Signature algorithm",
  "help_signature_algorithm": "Algorithm for signing messages, both XML and URL. Select the algorithm to use when signing requests.\nThe default value is nowadays \"SHA-256\", which is usually preferred in more recent configurations and a more secure option.\nThis algorithm controls all types of signing if signing is enabled.\n",
  "always_use_post_binding": "Always use post binding",
  "help_always_use_post_binding": "Prefer http POST method over Redirect for SSO requests. \nThis checkbox makes requests and responses prefer HTTP-POST binding over HTTP-Redirect binding when this is supported. This may be used if URLs are large and the IdP does not accept large URLs.\nBy default this option is not enabled.",
  "label_prefer_http_post": "Saml Binding",
  "prefer_http_post": "Prefer HTTP POST",
  "help_prefer_http_post": "This option will make the the SAML authentiction use HTTP-POST instead of HTTP-Redirect. This may be used if the IdP does not accept large URLs.\nBy default this option is disabled (meaning HTTP-Redirect is used). Checking this without knowing if it is supported by the IdP is not recommended.",
  "label_slo_enabled": "Identity-provider logout",
  "slo_enabled": "End the identity-provider session on logout",
  "help_slo_enabled": "When a user logs out of TimeEdit, TimeEdit also asks your identity provider to end its session — which may sign them out of other apps that share this login. Requires an IdP logout URL. Off by default; TimeEdit's cross-tab logout is unaffected.",
  "error_slo_missing_logout_url": "Identity-provider logout is on but no IdP logout URL is set, so it won't run. Add a logout URL (from metadata or manually) or turn this off.",
  "attributes_parsing": "Attributes parsing",
  "user_name_attribute": "User name attribute",
  "help_user_name_attribute": "Name of username attribute. The attribute name in the SAML response which corresponds to the users username.\nExample: \"eduPersonPrincipalName\"\nIt is possible to extract only part of the attribute value as the username by specifying the attribute name followed by an equals sign and then the pattern of the value, where ? marks the actual username.\nExample: \"mail=?@timeedit.se\"",
  "email_attribute": "E-mail attribute",
  "help_email_attribute": "Name of e-mail attribute. The attribute name in the SAML response which corresponds to the users e-mail address.",
  "given_name_attribute": "Given name attribute",
  "help_given_name_attribute": "Name of the users given name attribute. The attribute name in the SAML response which corresponds to the users given name.",
  "last_name_attribute": "Last name attribute",
  "help_last_name_attribute": "Name of the users last name attribute. The attribute name in the SAML response which corresponds to the users last name.",
  "mandatory_attributes": "Mandatory attributes",
  "help_mandatory_attributes": "Values that must be set for the given attributes. \nA list of attributes that are mandatory for all users.",
  "forbidden_attributes": "Forbidden attributes",
  "help_forbidden_attributes": "List of attributes with values that a user must NOT have in order to log in.\nA list of attributes that are forbidden for all users.",
  "user_object_matching": "User object matching",
  "help_user_object_matching": "help_text_missing",
  "OBJECT_EXTID": "OBJECT EXTID",
  "OBJECT_FIELD": "OBJECT FIELD",
  "user_object_extid": "SAML2 pattern for matching user objects",
  "help_user_object_extid": "Pattern which can add to the attribute value when matched with a field value. For example if the desired field contains \"student_123\" and the attribute value is \"123\" then the pattern should be \"student_?\". The ? represents where the attribute value will be inserted by the login process once the user logs in.",
  "user_object_field": "TimeEdit field for user objects",
  "help_user_object_field": "Specify which field to match with the attribute value when selecting user objects. ExtId will be used by default if no other field is set. Any field can be used, but should preferrably be \"unique\" and \"searchable\".",
  "user_object_attribute": "SAML2 attribute for user objects",
  "help_user_object_attribute": "Specify which SAML attribute to use for user objects. The attribute value will be matched with the field value.",
  "mandatory_user_object": "Mandatory user object",
  "help_mandatory_user_object": "Set if user object should be mandatory or not. \nSelect if the user object should be mandatory. \nIf yes AND the user object field is not empty, then the user will only be allowed into the system if a user object is found. \nIf no, a user object is set if it is found, but in either case the user is allowed to login.",
  "set_permissions": "Set permissions",
  "help_set_permissions": "Set when the authentication plugin should set user permissions. \nSelect when authentication sets the user permission.\nAlways: Always set permissions based on this configuration.\nNew users: Set permissions based on this configuration or users the first time they login.\nNever:  Never set any permissions when authenticating.",
  "ALWAYS": "ALWAYS",
  "NEW_USERS": "NEW USERS",
  "NEVER": "NEVER",
  "affiliations": "Affiliations",
  "affiliations_count": "{0} affiliations",
  "manage_affiliations": "Manage affiliations",
  "manage_affiliations_tooltip": "Please save authentication config before managing affiliations",
  "help_affiliations": "Configure user affiliation by assigning nodes and roles, user objects and standard organization based on the SAML response attributes. For each affiliation add one or more attribute key value pairs for matching (case insensitive). Then configure which nodes and roles, user objects and standard organization the user should receive. Userobjects and standard organization is optional.",
  "require_full_attribute_matches": "Require full attribute match",
  "help_require_full_attribute_matches": "Require full matches when comparing attribute and value. When enabled the attribute must match the exact value (case insensitive). Example: An attribute 'department' with value 'engineering' will not match 'engineer'. When disabled an attribute value 'engineering' will match 'engineer', but not the other way around.",
  "affiliation_matching": "Affiliation matching",
  "allow_single_affiliation_match": "Allow single affiliation match",
  "allow_multiple_affiliation_matches": "Allow multiple affiliation matches",
  "help_allow_multiple_affiliation_matches": "When enabled the user will recieve nodes and roles and userobjects from all matched rows. Standard organization is assigned from the first match which contains a standard organization. When disabled the user will receive nodes and roles, userobjects and standard organization from the first match. Order is from the top to bottom.",
  "attributes": "Attributes",
  "values": "Values",
  "add_row": "Add row",
  "add_permission": "Add permission",
  "attributes_pattern": "Attributes pattern",
  "help_attributes_pattern": "Attributes condition pattern. If the attributes evaluate to true the corresponding permissions will be added. \nThe pattern has the same form as the \"mandatory attributes\". An empty value will always evaluate to \"true\".",
  "organization_role": "Organization / role",
  "help_organization_role": "User organizations and roles. \nOrganizations and roles of the user. Entered on the format: \n\"org1=role1\", \"org2=role2\" ... \"orgN=roleN\"\nAn organization may be given as a path separated by ;",
  "help_auth_configs_standard_organization": "User standard organization. Standard organization of the user. \nAn organization may be given as a path separated by ;",
  "help_auth_configs_user_objects": "Additional user objects.\nA list of external object ids separated by new line.\nExample: \"dep_sales\" \n\"dep_support\"\n\"course_abc123\"\n\"course_cde345\"",
  "editable_features": "Editable features",
  "move": "Move",
  "are_you_sure_to_move": "Are you sure you want to move",
  "reservations_from": "reservation(s) from",
  "preserving_local_time": "preserving local time",
  "number_of_reservations_moved": "Number of reservations moved",
  "number_of_cancellations_moved": "Number of cancellations moved",
  "number_of_history_reservations_moved": "Number of history reservations moved",
  "number_of_culls_moved": "Number of culls moved",
  "help_text_restemplates_timerule": "help_text_missing",
  "help_text_restemplates_privaterole": "help_text_missing",
  "help_text_restemplates_standardorg": "help_text_missing",
  "help_text_restemplates_active": "help_text_missing",
  "help_text_restemplates_affectorders": "help_text_missing",
  "help_text_restemplates_deafultstatus": "help_text_missing",
  "help_text_delete_reservations_when_culling": "help_text_missing",
  "help_text_restemplates_movereservations_count": "help_text_missing",
  "help_text_types_personaldata": "help_text_missing",
  "help_text_types_aliastype": "help_text_missing",
  "help_text_types_external_ownership": "help_text_missing",
  "help_text_periods_user_access": "help_text_missing",
  "sub_organizations": "Sub-organizations",
  "sure_to_delete_org": "Are you sure to delete this organization",
  "delete_organization": "Delete organization",
  "url": "URL",
  "YES": "Yes",
  "NO": "No",
  "STANDARD": "Standard",
  "HIDDEN": "Hidden",
  "READ_ONLY": "Read only",
  "visibility": "Visiblity",
  "last_login": "Last login",
  "active_user": "Active user",
  "require_password_on_first_sign_in": "Require password on first sign in",
  "user_will_be_required_to_set_new_password_on_first_log_in": "User will be required to set new password on first log in",
  "app_permission": "App permission",
  "app_permissions": "App permissions",
  "scopes": "Scopes",
  "scopes_to_choose_from": "Scopes to choose from",
  "role": "Role",
  "organizations_and_roles": "Organizations and roles",
  "set_app_permissions": "Set app permissions",
  "authentication_configuration": "Authentication configuration",
  "authentication_configurations": "Authentication configurations",
  "readOnly": "Read only",
  "add_language": "Add language",
  "padding": "Padding",
  "new_padding_rule": "New padding rule",
  "objects_type": "Object type",
  "field_criteria": "Field criteria (field ext id)",
  "field_values": "Field values",
  "object_ext_id": "Object ext id",
  "impactedObject": "Impacted object",
  "time_conditionality": "Time conditionality",
  "start_before": "Starts before",
  "end_after": "Ends after",
  "before": "Before",
  "after": "After",
  "select_field": "Select field",
  "select_value": "Select value",
  "padding_rules": "Padding rules",
  "direct_padding": "Direct padding",
  "travel_time_padding": "Travel time padding",
  "select_padding_type": "Select padding type",
  "controlling_objects": "Controlling objects",
  "padding_viewer": "Padding viewer",
  "rules": "Rules",
  "add_rule": "Add rule",
  "select_reservation_template": "Select reservation template",
  "add_object_criteria": "Add object criteria",
  "locked_for_external_authentication": "Locked for external authentication",
  "contact_email": "Contact E-mail",
  "help_api_key_storage": "Copy and store this key safely. This key cannot be retrieved again.",
  "help_api_key_regenerate": "Use Generate Key to create a new key.",
  "help_api_key_properties": "You can change properties of existing keys.",
  "integration.calendar.configuration.delete_confirmation": "Are you sure you want to delete this configuration?",
  "integration.calendar.configuration.title": "Configuration",
  "integration.calendar.configuration.subtitle": "Configure information required to integrate with Microsoft 365",
  "integration.calendar.configuration.alert.title": "Proceed with caution",
  "integration.calendar.configuration.alert.description": "Correct values are required to establish the Microsoft 365 integration.",
  "integration.calendar.configuration.form.title": "Configure the integration settings for communicating with Microsoft 365",
  "integration.calendar.configuration.form.client_id.description": "Application client ID for authenticating communication with Microsoft 365.",
  "integration.calendar.configuration.form.client_id.label": "Client ID",
  "integration.calendar.configuration.form.client_secret.description": "Application client secret for authenticating communication with Microsoft 365. Use to update the client secret, but the secret will not be exposed when displaying the configurations.",
  "integration.calendar.configuration.form.client_secret.label": "Client secret",
  "integration.calendar.configuration.form.name.description": "Name of the application client.",
  "integration.calendar.configuration.form.name.label": "Name",
  "integration.calendar.configuration.form.tenant_id.description": "Tenant ID for the authentication client for Microsoft 365 integration.",
  "integration.calendar.configuration.form.tenant_id.label": "Tenant ID",
  "integration.calendar.logs.title": "Logs",
  "integration.calendar.logs.subtitle": "View logs and track integration status over time ",
  "integration.calendar.logs.error": "Failed to fetch logs",
  "integration.calendar.audit.title": "Change history",
  "integration.calendar.audit.user": "User",
  "integration.calendar.audit.action.CREATED": "Created",
  "integration.calendar.audit.action.UPDATED": "Updated",
  "integration.calendar.audit.action.DELETED": "Deleted",
  "integration.calendar.audit.error": "Failed to fetch change history",
  "integration.calendar.mapping.title": "Mapping",
  "integration.calendar.mapping.subtitle": "Configure how data should be mapped between TimeEdit and Microsoft 365",
  "integration.calendar.mapping.actions.save_changes": "Save",
  "integration.calendar.mapping.actions.discard_changes": "Discard changes",
  "integration.calendar.mapping.general.title": "General",
  "integration.calendar.mapping.general.reservation_mode": "Reservation mode",
  "integration.calendar.mapping.general.subject_field": "Subject field",
  "integration.calendar.mapping.general.description_field": "Description field",
  "integration.calendar.mapping.room.title": "Room",
  "integration.calendar.mapping.staff.title": "Staff",
  "integration.calendar.mapping.student.title": "Student",
  "integration.calendar.mapping.object.room.object_type_tooltip": "Object type representing rooms.",
  "integration.calendar.mapping.object.staff.object_type_tooltip": "Object type representing staff.",
  "integration.calendar.mapping.object.student.object_type_tooltip": "Object type representing students.",
  "integration.calendar.mapping.object.object_filter_tooltip": "Field containing the mailbox address.",
  "integration.calendar.mapping.object.room.object_name_field_tooltip": "Field containing the name of the room.",
  "integration.calendar.mapping.object.object_type": "Object type",
  "integration.calendar.mapping.object.object_filter": "Email field",
  "integration.calendar.mapping.object.name_field": "Name field",
  "integration.calendar.mapping.error.save_failed": "An unknown error occurred while saving the mapping.",
  "integration.calendar.mapping.success.save_successful": "Mapping saved successfully.",
  "integration.calendar.sync_settings.title": "Sync Settings",
  "integration.calendar.sync_settings.subtitle": "Setup synchronisation between TimeEdit and Microsoft 365",
  "integration.calendar.sync_settings.actions.save_changes": "Save",
  "integration.calendar.sync_settings.actions.discard_changes": "Discard changes",
  "integration.calendar.sync_settings.category_color.save_successful": "Category color saved successfully.",
  "integration.calendar.sync_settings.category_color.label": "Category color",
  "integration.calendar.sync_settings.category_color.tooltip": "Select a color for the Microsoft Outlook category, which will be applied to events synced from TimeEdit.",
  "integration.calendar.sync_settings.actions.confirm_delete": "Are you sure you want to delete this sync setting?",
  "integration.calendar.sync_settings.form.objects.title": "Objects to sync",
  "integration.calendar.sync_settings.section.event.info.title": "Event information",
  "integration.calendar.sync_settings.form.name.description": "Name of the sync setting.",
  "integration.calendar.sync_settings.form.name.label": "Name",
  "integration.calendar.sync_settings.form.reservation_mode.description": "Only sync reservations of the selected modes",
  "integration.calendar.sync_settings.form.reservation_mode.label": "Reservation mode",
  "integration.calendar.sync_settings.form.reservation_mode.placeholder": "Select reservation modes",
  "integration.calendar.sync_settings.form.reminder.description": "Reminder applied when an event is first synced to Outlook.",
  "integration.calendar.sync_settings.form.reminder.label": "Reminder",
  "integration.calendar.sync_settings.form.reminder.option.outlook_default": "Use Outlook default",
  "integration.calendar.sync_settings.form.reminder.option.none": "No reminder",
  "integration.calendar.sync_settings.form.reminder.option.at_time_of_event": "At time of event",
  "integration.calendar.sync_settings.form.reminder.option.five_minutes": "5 minutes before",
  "integration.calendar.sync_settings.form.reminder.option.ten_minutes": "10 minutes before",
  "integration.calendar.sync_settings.form.reminder.option.fifteen_minutes": "15 minutes before",
  "integration.calendar.sync_settings.form.reminder.option.thirty_minutes": "30 minutes before",
  "integration.calendar.sync_settings.form.reminder.option.one_hour": "1 hour before",
  "integration.calendar.sync_settings.form.reminder.option.one_day": "1 day before",
  "integration.calendar.sync_settings.form.reservation_status.description": "Only sync reservations of the selected statuses",
  "integration.calendar.sync_settings.form.reservation_status.label": "Reservation status",
  "integration.calendar.sync_settings.form.reservation_status.placeholder": "Select reservation statuses",
  "integration.calendar.sync_settings.form.subject_field_id.description": "Field to be used as the title of the calendar event",
  "integration.calendar.sync_settings.form.subject_field_id.label": "Subject field",
  "integration.calendar.sync_settings.form.subject_field.add_btn.label": "Add alternative",
  "integration.calendar.sync_settings.form.subject_field.remove_btn.label": "Remove selected alternatives",
  "integration.calendar.sync_settings.form.description_field.add_btn.label": "Add row",
  "integration.calendar.sync_settings.form.description_field.remove_btn.label": "Remove selected rows",
  "integration.calendar.sync_settings.form.location_field.add_btn.label": "Add alternative",
  "integration.calendar.sync_settings.form.location_field.remove_btn.label": "Remove selected alternatives",
  "integration.calendar.sync_settings.form.description_field_ids.description": "Field to be included in the descripiton of the calendar event",
  "integration.calendar.sync_settings.form.description_field_ids.label": "Description fields",
  "integration.calendar.sync_settings.form.sync_mode.description": "Direction to sync the objects",
  "integration.calendar.sync_settings.form.sync_mode.label": "Sync mode",
  "integration.calendar.sync_settings.form.sync_period.description": "Choose whether to sync by an absolute or relative time interval.",
  "integration.calendar.sync_settings.form.sync_period.label": "Time interval type",
  "integration.calendar.sync_settings.form.sync_period.static.start_date.description": "Start of the period to sync",
  "integration.calendar.sync_settings.form.sync_period.static.start_date.label": "Start date",
  "integration.calendar.sync_settings.form.sync_period.static.end_date.description": "End of the period to sync",
  "integration.calendar.sync_settings.form.sync_period.static.end_date.label": "End date",
  "integration.calendar.sync_settings.form.sync_mode.te_in.label": "Microsoft 365 → TimeEdit",
  "integration.calendar.sync_settings.form.sync_mode.te_out.label": "TimeEdit → Microsoft 365",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.add_component": "Add component",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.room_subject_alert_text": "For room reservations, room events will use the organisers name as the subject unless configured otherwise.",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.room_subject_alert_link": "Read more",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.edit_template_modal.title": "Edit subject field",
  "integration.calendar.sync_settings.form.sync_mode.te_out.location.edit_template_modal.title": "Edit location field",
  "integration.calendar.sync_settings.form.sync_mode.te_out.template_column.value": "Value",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.static_text_modal.title": "Add static text",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.field_type.reservation_field": "Reservation field",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.field_type.reservation_info": "Reservation info",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.field_type.reservation_id": "Reservation ID",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.field_type.reservation_status_c": "Confirmation status",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.field_type.object_field": "Object field",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.field_type.free_text": "Free text",
  "integration.calendar.sync_settings.form.sync_mode.te_out.free_text.blank_space": "BLANK_SPACE",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.remove_empty_template.title": "Remove template?",
  "integration.calendar.sync_settings.form.sync_mode.te_out.subject.remove_empty_template.content": "This template has no fields and will be removed.",
  "integration.calendar.sync_settings.form.sync_mode.te_two_way.label": "Two-way sync",
  "integration.calendar.sync_settings.form.sync_period.static.label": "Absolute interval",
  "integration.calendar.sync_settings.form.sync_period.relative.label": "Relative interval",
  "integration.calendar.sync_settings.form.sync_period.date_range.label": "Date Range",
  "integration.calendar.sync_settings.form.sync_period.interval.label": "Interval (days)",
  "integration.calendar.sync_settings.form.sync_period.interval.tooltip": "Number of days in future to sync. Limit: 1 - 365 days.",
  "integration.calendar.sync_settings.form.sync_target.description": "Determines what objects to sync",
  "integration.calendar.sync_settings.form.sync_target.label": "Sync target",
  "integration.calendar.sync_settings.form.sync_target.option.all": "All",
  "integration.calendar.sync_settings.form.sync_target.option.selected": "Selected",
  "integration.calendar.sync_settings.form.sync_target.option.filtered": "Filtered",
  "integration.calendar.sync_settings.form.sync_type.description": "Type of object to sync.",
  "integration.calendar.sync_settings.form.sync_type.label": "Type",
  "integration.calendar.user_status.title": "User Status",
  "integration.calendar.user_status.subtitle": "View usage status per user",
  "integration.calendar.event_mappings.title": "Event Mappings",
  "integration.calendar.event_mappings.subtitle": "View event mappings between TE and Outlook",
  "integration_settings_danger_zone": "Danger zone",
  "integration_settings_danger_zone_description": "Editing properties here can break your connection with the TimeEdit server. Proceed with caution",
  "integration_settings_header": "Configure the integration settings for communicating with TE Server",
  "integration_settings_base_url": "Base URL",
  "integration_settings_base_url_description": "The URL that should be used to connect to the TimeEdit server",
  "integration_settings_base_url_required": "Base URL is required",
  "integration_settings_username": "Username",
  "integration_settings_username_description": "The username that should be used to authenticate with the TimeEdit server",
  "integration_settings_username_required": "Username is required",
  "integration_settings_password": "Password",
  "integration_settings_password_description": "The password that should be used to authenticate with the TimeEdit server",
  "integration_settings_password_required": "Password is required",
  "integration_settings_certificate": "Certificate key",
  "integration_settings_certificate_description": "The certificate key that should be used to authenticate with the TimeEdit server",
  "integration_settings_certificate_required": "Certificate key is required",
  "action_is_required": "Action is required",
  "MON": "Mon",
  "TUE": "Tue",
  "WED": "Wed",
  "THU": "Thu",
  "FRI": "Fri",
  "SAT": "Sat",
  "SUN": "Sun",
  "save": "save",
  "Show_link_when": "Show link when",
  "this_controls_when": "This controls when the link is visible to the submitter, and when the scheduler can notify the submitter",
  "display_and_notification_settings": "Display and notification settings",
  "if_this_settings": "Note: If this settings isn't configured, the link will always be hidden",
  "review_settings_let_you_configure": "Review settings let you configure how and when your submitters are able to view schedule in Viewer",
  "create_new_combination": "Create new study combination",
  "name_is_required": "Name is required",
  "expected_enrollment_is_required": "Expected enrollment is required",
  "program": "Program",
  "program_is_required": "Program is required",
  "mandatory_courses": "Mandatory courses",
  "elective_courses": "Elective courses",
  "label_selected_study_comb": "Select courses to include in Study combinations",
  "show_only_related_objects": "Show only related objects",
  "total_credits": "Total credits",
  "expected_enrollment": "Expected enrollment",
  "historical_enrollment": "Historical Enrollment",
  "approve_selected": "Approve selected",
  "reject_selected": "Reject selected",
  "create_new": "Create new",
  "approve_study_combination": "Are you sure you want to approve {0} study combinations?",
  "reject_study_combination": "Are you sure you want to reject {0} study combinations?",
  "confirm_to_allocate_student_sets_after_generated_title": "Student set generation finished. Do you want to allocate the Student sets to the activities?",
  "confirm_to_allocate_selected_student_sets_title": "Do you want to allocate the selected Student sets to the activities",
  "confirm_to_allocate_selected_student_sets_message": "{0} student sets were generated based on the {1} selected Study Combinations.",
  "confirm_to_allocate_selected_student_sets_note": "Note: After the Student sets have been allocated they can no longer be regenerated or deleted in Data Manager and can only be handled in TE Core",
  "allocate_later": "Allocate later",
  "allocate_student_sets": "Allocate Student sets",
  "student_set_generation_failed_title": "Student set generation failed",
  "student_set_generation_failed_description": "Unfortunately, the generation of student sets failed with this error message",
  "student_set_allocation_failed_title": "Student set allocation failed",
  "student_set_allocation_failed_description": "Unfortunately, the allocation of student sets failed with this error message",
  "student_set_allocation_failed_description_multiple": "Unfortunately, not the complete allocation has been successfully. Some errors occured",
  "student_set_missing_data_title": "Missing or problematic activity data",
  "student_set_missing_data_description": "Unfortunately, we could not fetch all necessary activity data for all courses from TE Preferences form submissions.",
  "review_study_combination.title": "Review Study Combinations",
  "review_study_combination.subtitle": "Review Study Combinations and set status to Approved to use them to generate student sets",
  "review_study_combination.tabs.review_by_study_combination.title": "Review by Study Combination",
  "review_study_combination.tabs.review_by_course.title": "Review by Course",
  "generate_student_sets.title": "Generate Student sets",
  "generate_student_sets.subtitle": "Student sets will be generated based on Study combinations and activity data for included courses",
  "generate_student_sets.started_title": "Generation started",
  "generate_student_sets.started_message": "Generation of student sets successfully started",
  "course_data_problem": "Course data problem",
  "study_combination": "Study Combination",
  "courses": "Courses",
  "credits": "Credits",
  "history_enrollment_shorten": "Hist. enrollment",
  "expected_enrollment_shorten": "Exp. Enrollment",
  "expected_enrollment_course_shorten": "Exp. enrol. course",
  "expected_enrollment_study_combination_shorten": "Exp. enrol. Study Comb.",
  "status": "Status",
  "showing_number_of_study_combinations": "Showing {0} of {1} study combinations",
  "showing_number_of_study_items": "Showing {0} of {1} {2}",
  "not_review": "Not review",
  "approve": "Approve",
  "accept": "Accept",
  "reject": "Reject",
  "replace": "Replace",
  "required": "Required",
  "no_study_combinations_warning": "There are no study combinations",
  "course": "Course",
  "inactive_course": "Inactive course",
  "study_combinations": "Study combinations",
  "number_of_study_combinations": "Number of Study combinations",
  "expected_enrolment_by_course": "Expected enrolment (Course)",
  "expected_enrolment_by_study_combination": "Expected enrolment (Study Combination)",
  "enrolment_diff": "Enrolment diff",
  "course_will_be_replace_in_study_combination_note": "{0} will be replaced in all Study Combinations where it is currently included",
  "replace_course_with": "Replace course with",
  "study_combination_is_already": "Study combination is already {0}",
  "study_combinations_where_is_mandatory": "Study combinations where {0} is mandatory",
  "study_combinations_where_is_elective": "Study combinations where {0} is elective",
  "replace_course_in_study_combination": "Replace course in study combination",
  "remove_course_from_study_combination": "Remove course from study combination",
  "study_combination_is_accepted_or_rejected": "Study combination is accepted or rejected",
  "course_is_included_in_this_study_combination": "{0} is included in this study combination",
  "please_select_study_combination": "Please select study combination",
  "mandatory_course_is_required": "Mandatory course is required",
  "submit": "Submit",
  "cannot_export_number_of_students": "Cannot export number of students",
  "branding_title": "Branding",
  "branding_subtitle": "Set logo, colors and control the apperance",
  "logo": "Logo",
  "logo_tooltip": "Customer logo. URL to image.",
  "logo_help": "Logo is used in the top bar for Hub, Curriculum, Studyguide and Evaluation",
  "logoViewer": "Logo for Viewer",
  "logoViewerLink": "Configure logo for Viewer",
  "logoCurriculum": "Logo for Curriculum",
  "logoCurriculumLink": "Override logo for Curriculum",
  "brand_no_color": "No color",
  "brand_color": "Brand color",
  "brand_color_help": "Brand color is used in the top bar for Hub, Curriculum, Studyguide and Evaluation",
  "system_general_setting_title": "General Settings",
  "system_general_setting_subtitle": "General settings for organization",
  "system_reservation_template_title": "Reservation Templates",
  "system_reservation_template_subtitle": "Manage templates",
  "system_padding_rule_title": "Padding Rules",
  "system_padding_rule_subtitle": "Manage padding rules",
  "system_padding_viewer_title": "Padding Viewer",
  "system_padding_viewer_subtitle": "View rules",
  "system_field_relation_title": "Field Relations",
  "system_field_relation_subtitle": "Manage field relations",
  "application_integration_setting_title": "Integrations Settings",
  "application_integration_setting_subtitle": "Manage integration settings",
  "report_settings": "Report Settings",
  "manage_data_source_types": "Manage Data Source Types",
  "manage_mapping": "Manage Mapping",
  "application_exam_setting_title": "Exam Settings",
  "application_exam_type_mapping_subtitle": "Object Types",
  "application_exam_in_core_subtitle": "TE Exam in TE Core",
  "application_exam_reservation_setting_subtitle": "Reservation Settings",
  "application_exam_object_relationship_subtitle": "Object Relationship",
  "review_settings": "Review Settings",
  "object_types": "Object Types",
  "object_types_subtitle": "Manage Object Types",
  "week_name": "Week Name",
  "delete_selected": "Delete selected",
  "preferences_settings": "Preferences Settings",
  "preferences_settings_pin_code_head_line": "Recipients Authentication",
  "preferences_settings_pin_code_info_box_head_line": "User Configuration",
  "preferences_settings_pin_code_head_prim_info": "To enable users to access and fill out a Preferences form, use the app permission “Preferences: Recipient”. Giving the scope “Preferences: User” will also allow users to fill out forms, but comes with additional access which normally is not preferable.",
  "preferences_settings_pin_code_head_prim_notes": "Notes",
  "preferences_settings_pin_code_head_prim_note_new_rec": "Only new recipients are affected. Existing ones keep their existing pin code.",
  "preferences_settings_pin_code_generate": "Pin code",
  "preferences_settings_pin_code_generate_tooltip_expl": " A random pin code is generated for each recipient, acting as a kind of “password”",
  "preferences_settings_pin_code_auth_signal": "Auth service",
  "preferences_settings_pin_code_auth_signal_tooltip_expl": "Using the general Auth config from the org, i.e. SSO or TimeEdit IdP)",
  "DIRECT": "Direct",
  "TRAVEL_TIME": "Travel time",
  "OBJECT_TYPE": "Object type",
  "FIELD_VALUE": "Field value",
  "EXT_IDS": "Ext. IDs (objects)",
  "dynamic_availability": "Dynamic Availability",
  "dynamic_availability_title": "Dynamic Availability Rules",
  "dynamic_availability_subtitle": "Manage dynamic availability",
  "TOTAL_HOURS": "Max available hours",
  "CONSECUTIVE_HOURS": "Max consecutive hours",
  "FREE_TIME": "Dynamic unavailability",
  "TOTAL_RESERVATIONS": "Max available reservations",
  "UNAVAILABILITY_DAILY": "Hours per day",
  "UNAVAILABILITY_WEEKLY": "Days per week",
  "UNAVAILABILITY_HOURS_WEEKLY": "Hours per week",
  "MAX_AVAILABLE_DAILY": "Hours per day",
  "MAX_AVAILABLE_WEEKLY": "Hours per week",
  "MAX_RESERVATIONS_DAILY": "Reservations per day",
  "MAX_RESERVATIONS_WEEKLY": "Reservations per week",
  "RESERVATION": "Reservation",
  "AVAILABILITY": "Availability reservation",
  "INFO_RESERVATION": "Info reservation",
  "reservation_template_confirmation_delete": "Are you sure to delete this reservation template?",
  "fields_confirmation_delete": "Are you sure you want to delete this field?",
  "padding_rule_confirmation_delete": "Are you sure you want to delete this padding rule?",
  "reservation_mode_confirmation_delete": "Are you sure you want to delete this reservation mode?",
  "user_confirmation_delete": "Are you sure you want to delete this user?",
  "field_relation_confirmation_delete": "Are you sure you want to delete this field relation?",
  "object_type_confirmation_delete": "Are you sure you want to delete this object type?",
  "new_field_relation": "New field relation",
  "clear_cache": "Clear cache",
  "clear_cache_confirm_message": "You are about to clear all cache for Preferences in this organization. Continue?",
  "clear_cache_success_message": "Cache cleared successfully",
  "dynamic_availability_confirmation_delete": "Are you sure you want to delete this dynamic availability?",
  "new_relation_type": "New relation type",
  "relation_type_confirmation_delete": "Are you sure you want to delete this relation type?",
  "USE_ONLY": "Use only",
  "STRICT": "Strict",
  "DYNAMIC": "Dynamic",
  "memberships": "Memberships",
  "memberships_subtitle": "Manage memberships",
  "membership_confirmation_delete": "Are you sure you want to delete this membership?",
  "new_membership": "New membership",
  "ABSTRACT": "Abstract",
  "PHYSICAL": "Physical",
  "availability_relations": "Availability Relations",
  "availability_relations_title": "Availability Relations",
  "availability_relations_subtitle": "Manage availability relations",
  "availability_relation_confirmation_delete": "Are you sure you want to delete this availability relation?",
  "new_availability_relation": "New availability relation",
  "INTEGER": "Integer",
  "TEXT": "Text",
  "CATEGORY": "Category",
  "CHECKBOX": "Checkbox",
  "SIGNATURE": "Signature",
  "EMAIL": "Email",
  "URL": "URL",
  "TELEPHONE": "Telephone",
  "COMMENT": "Comment",
  "LENGTH": "Length",
  "REFERENCE": "Reference",
  "NON_SEARCHABLE_TEXT": "Non searchable text",
  "NON_SEARCHABLE_REFERENCE": "Non searchable reference",
  "SHOW_ALL": "Show all",
  "org_visibility_public": "Customer production",
  "org_visibility_hidden": "Customer other (test/acceptance etc)",
  "org_visibility_private": "Internal (shown when using \"internal:\" search prefix)",
  "time_rules": "Time Rules",
  "time_rules_subtitle": "Manage time rules",
  "time_rule_confirmation_delete": "Are you sure you want to delete this time rule?",
  "period_confirmation_delete": "Are you sure you want to delete this period?",
  "new_time_rule": "New time rule",
  "support_info": "Support Info",
  "support_info_subtitle": "The support info is visible in Core under Help > Support",
  "manage_periods": "Manage periods",
  "time_rule_active_criteria": "Active Criteria",
  "advanced_preferences_title": "Advanced",
  "advanced_preferences_subtitle": "Advances system preferences",
  "holiday_reservations_title": "Holiday reservations",
  "holiday_reservations_subtitle": "Manage holiday reservations",
  "manage_viewer_page": "Viewer Link",
  "manage_reservation_page": "Reservation Comment",
  "manage_period_page": "Current period",
  "manage_reservation_filter_page": "Reservation Filter",
  "hubViewerLinkHelp": "Subscribe requires a configured page in Viewer. \n Ensure that students has access to the entrance and the page configured.",
  "reservation_filter": "Reservation Filter",
  "manage_period_help": "Restrict objects and reservations to a period for Allocate and Registration",
  "automatic_allocation_label": "Automatic Allocation",
  "automatic_allocation_tooltip": "Allocate students to activities where there is only one option (group), ignoring conflicts",
  "automatic_de_allocation_label": "Automatic De-allocation",
  "automatic_de_allocation_tooltip": "Deallocate students who are allocated to groups where they are no longer enrolled in the module",
  "automatic_allocation_info": "Helps you maintain allocations:",
  "frequency_title": "Frequency",
  "frequency_daily_label": "Daily",
  "frequency_daily_tooltip": "Runs every night. It will take all modules within the filter of the current period into account.",
  "frequency_hourly_label": "Hourly",
  "frequency_hourly_tooltip": "Runs every hour at 17 minutes past the hour. It will look at students modified within the last hour and update their allocations. The student has to be enrolled or a member of a group related to a module within the filter.",
  "frequency_every_minute_label": "Every minute",
  "frequency_every_minute_tooltip": "Runs every minute. It will look at students modified within the last 5 minutes and update their allocations (to use this feature, please contact Customer Support).",
  "frequency_manually_info": "Limit Automatic Allocation to run only if manually triggered: set all frequency sliders (daily/hourly/every minute) to Disabled. Allocate::Admin users can trigger Automatic Allocation manually under Allocate>settings>Run Auto Allocation. Allocation and deallocation settings still apply.",
  "frequency_info": "Setup the frequency of when to evaluate allocations and de-allocations:",
  "schedule_preferences_section": "Schedule preferences",
  "preferencesTimeOfDay": "Time of Day preferences",
  "preferencesTimeOfDay_help": "Collect morning, afternoon preferences",
  "preferencesTimeOfDay_info": "Allow students to pick time of day preferences.",
  "preferencesTime": "Time preferences",
  "preferencesTime_help": "Collect time preferences",
  "preferencesTime_info": "Allow students to pick time preferences.",
  "preferencesGroup": "Group preferences",
  "preferencesGroup_help": "Collect specific group preferences",
  "preferencesGroup_info": "Allow students to pick specific groups as a preferences.",
  "registration_section": "Registration",
  "block_student_conflict_tooltip": "Prevent student from register when there is a schedule conflict",
  "allowed": "Allowed",
  "notallowed": "Not allowed",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "registerToConflicts": "Register to conflicts",
  "label_block_student_conflict": "Disable register button on conflicts",
  "label_allow_student_conflict": "Enable register button on conflicts",
  "block_student_conflict_help": "Disable the register button in Registration for students when there are any schedule conflicts for the reservations of that group.",
  "waitlist": "Waitlist",
  "label_waitlist_on": "Enable waitlist",
  "label_waitlist_off": "Disable waitlist",
  "manage_waitlist_help": "Enable waitlist so that when a group is full a student can add themself to a waitlist (to use this feature, please contact Customer Support).",
  "allocate_general_settings": "General Settings",
  "automatic_allocation_from_waitlist_label": "Automatic allocation from waitlist",
  "automatic_allocation_from_waitlist_tooltip": "Automatically allocate students from the waitlist when a slot becomes available.",
  "time_zones": "Time Zones",
  "time_zones_subtitle": "Manage time zones",
  "time_zone_confirmation_delete": "Are you sure you want to delete this time zone?",
  "data_sources": "Data Sources",
  "data_sources_subtitle": "Manage data sources",
  "new_data_sources": "New data sources",
  "report_template": "Report templates",
  "manage_report_template": "Manage report templates",
  "report_template_confirmation_delete": "Are you sure you want to delete this report template?",
  "data_sources_confirmation_delete": "Are you sure you want to delete this data sources?",
  "help_metadata_url": "By adding the customers idp metadata url you can import the subsequent information from the metadata.\nThe button will only fill in the values, you must still press the save button.",
  "autofill_from_metadata": "Autofill from metadata",
  "help_autofill_from_metadata": "After filling in \"IdP Metadata URL\" and \"IdP Entity Id\" this button can be used to autofill remaining fields from the metadata. Remember to save, the button will only fill in the input fields. The \"Prefer HTTP POST\"-checkbox can be checked before autofilling, it will uncheck itself if no post binding is found in the metadata by the autofill.",
  "object_confirmation_delete": "Are you sure you want to delete this object?",
  "exam_v3_object_type_settings_title": "Object type settings",
  "exam_v3_object_type_settings_sub_title": "Object type",
  "exam_v3_reservation_settings_title": "Reservation settings",
  "exam_v3_reservation_settings_sub_title": "Reservation",
  "seat_management_settings_title": "Seat Allocation Settings",
  "seat_management_allocation_mode_sub_title": "Seat Allocation",
  "allocateViewerLinkHelp": "In Allocate Overview in the drawer, users can navigate to detailed views of the group object, module, or the group's schedule. \n Allocate requires a configured page in Viewer, its recomended to create a dedicated page for Allocate that can be hidden in the entrance. \n Ensure that users of Allocate has access to the entrance and the page configured.",
  "allocateReservationCommentHelp": "Optional. \n Comment field on a reservation. \n When used the field is editable in Allocate. \n The field can be used to be able to carry a text comment from Preferences.",
  "LOAD": "Load",
  "UTILIZATION": "Utilization",
  "DEMAND_ANALYTIC": "Demand Analytic",
  "HEATMAP": "Heatmap",
  "allocateCurrentPeriodHelp": "The current period settings control which data is available throughout Allocate and Registration, affecting both what the user sees and the scope for automatic allocation.",
  "allocateCurrentPeriodReservationHelp": "Set a date range to focus on relevant reservations for your current allocation period.\n Only reservations within these dates will be shown and used in Allocate and Registration.",
  "allocateFilterReservationHelp": "Set a reservation mode only show and use relevant reservations for conflict control.\n Only reservations with the reservation mode will be shown and used for conflict control in Allocate and Registration.",
  "allocateFilterReservationStatusHelp": "Allocate will fetch reservations with the selected statuses",
  "allocateCurrentPeriodFilterCategoryHelp": "This filter defines which modules appear in Allocate and Registration, affecting both the interface and automatic allocation.\nUse this to filter out modules relevant for the current allocation period. Recommended fields to filter on are academic year and semester.\n\nNote that this filter will not affect any other objects such as student groups. Select category fields that are used specifically by module objects to ensure accurate filtering.",
  "notACategoryField": "Not a category field {0}",
  "courseModuleFilter": "Module filter",
  "reservations": "Reservations",
  "limitReservations": "Limit reservations to show and use for conflict control within this period.",
  "filterReservations": "Limit reservations to show and use for conflict control.",
  "reservationMode": "Reservation mode",
  "reservationModeSelect": "Select reservation mode",
  "reservationModeAll": "All",
  "data_manager.study_combinations_mapping.tab.title": "Study comb. mapping",
  "data_manager.study_combinations_mapping.page.title": "Study Combinations Mapping",
  "data_manager.study_combinations_mapping.page.subtitle": "Map what object types and fields that Study combinations should use for each period",
  "data_manager.study_combinations_mapping.page.actions.save": "Save",
  "data_manager.study_combinations_mapping.page.actions.discard_changes": "Discard changes",
  "data_manager.study_combinations_mapping.page.table.column.period": "Period",
  "data_manager.study_combinations_mapping.page.table.column.primary_object": "Primary object",
  "data_manager.study_combinations_mapping.page.table.column.activity_type": "Activity type",
  "data_manager.study_combinations_mapping.page.table.column.expected_enrolment": "Expected enrolment",
  "data_manager.study_combinations_mapping.page.table.column.track_max_capacity": "Track max capacity",
  "data_manager.study_combinations_mapping.page.table.header.number_of_periods": "{0} periods",
  "data_manager.study_combinations_mapping.page.error_result.title": "Failed to fetch all necessary data",
  "data_manager.study_combinations_mapping.page.error_result.subtitle": "There was an error when connecting to the server, please reload to try again",
  "data_manager.study_combinations_mapping.page.error_result.actions.retry": "Retry",
  "data_manager.study_combinations_mapping.page.error_result.error_list": "The following errors occurred",
  "data_manager.study_combinations_mapping.page.error_result.fetch_pathway_configs": "Failed to fetch pathway configurations",
  "data_manager.study_combinations_mapping.page.error_result.fetch_object_types": "Failed to fetch object types",
  "data_manager.study_combinations_mapping.page.error_result.fetch_fields": "Failed to fetch fields",
  "data_manager.study_combinations_mapping.page.error_result.unknown_error": "Unknown error",
  "data_manager.study_combinations_mapping.add_and_use_own_input": "Add and use own input",
  "products.data_manager": "Data Manager",
  "ui.action.add": "Add",
  "ui.action.delete": "Delete",
  "ui.action.remove": "Remove",
  "ui.table.edit_columns": "Edit columns",
  "object_manager.object_table.update.button": "Update",
  "object_manager.object_table.update.description": "A batch operation has completed. Reload the table to see the latest data.",
  "object_manager.object_table.column.ext_id": "Ext ID",
  "object_manager.object_table.column.types": "Type(s)",
  "object_manager.object_table.column.organizations": "Organisation(s)",
  "object_manager.object_table.column.active": "Active",
  "object_manager.object_table.data.active": "Active",
  "object_manager.object_table.data.inactive": "Inactive",
  "object_manager.object_table.data.yes": "Yes",
  "object_manager.object_table.data.no": "No",
  "object_manager.object_table.context_menu.open": "Open",
  "object_manager.object_table.context_menu.compare": "Compare",
  "object_manager.object_table.context_menu.duplicate": "Duplicate",
  "object_manager.object_table.context_menu.delete": "Delete",
  "object_manager.object_table.actions.create_new": "Create new",
  "object_manager.object_table.actions.edit": "Edit",
  "object_manager.object_table.actions.duplicate": "Duplicate",
  "object_manager.object_table.actions.delete": "Delete",
  "object_manager.object_table.actions.export": "Export",
  "object_manager.object_table.footer.selected_items": "{0} selected",
  "object_manager.object_table.drawer.associations.title": "Associations",
  "object_manager.object_table.drawer.associations.context_menu.remove": "Remove",
  "object_manager.object_table.drawer.associations.actions.add": "Add",
  "object_manager.object_table.drawer.associations.actions.add.tooltip.disabled": "Associations of this type cannot be added to the object.",
  "object_manager.object_table.drawer.associations.actions.remove": "Remove",
  "object_manager.object_table.drawer.associations.memberships.title": "Memberships",
  "object_manager.object_table.drawer.associations.relations.title": "Relations",
  "object_manager.object_table.drawer.associations.availability_related.title": "Availability related",
  "object_manager.object_table.drawer.associations.optional_related.title": "Optional related",
  "object_manager.select_objects_modal.title": "Add objects",
  "object_manager.adjust_filters_modal.title": "Adjust filter",
  "object_manager.bulk-edit-dropdown.general.label": "General info",
  "object_manager.bulk-edit-dropdown.fields.label": "Fields",
  "object_manager.bulk-edit-dropdown.associations.label": "Relations and memberships",
  "object_manager.bulk-edit-dropdown.organizations.label": "Organizations",
  "object_manager.bulk-edit-modal.title": "Edit objects",
  "object_manager.bulk-edit-modal.general.title": "Edit general info",
  "object_manager.bulk-edit-modal.general.property.label": "Property",
  "object_manager.bulk-edit-modal.general.personal-information.label": "Personal data",
  "object_manager.bulk-edit-modal.general.is-active.label": "Is Active",
  "object_manager.bulk-edit-modal.general.types.label": "Type",
  "object_manager.bulk-edit-modal.associations.title": "Edit associations",
  "object_manager.bulk-edit-modal.organizations.title": "Edit Organizations",
  "object_manager.bulk-edit-modal.subtitle": "{0} {1} objects selected",
  "object_manager.bulk-edit-modal.okText": "Update objects",
  "object_manager.bulk-edit-modal.keep.label": "Keep as is",
  "object_manager.bulk-edit-modal.removeAll.label": "Clear",
  "object_manager.bulk-edit-modal.add.label": "Add",
  "object_manager.bulk-edit-modal.findReplace.label": "Find and replace",
  "object_manager.bulk-edit-modal.replaceAll.label": "Replace all",
  "object_manager.bulk-edit-modal.removeSpecific.label": "Remove specific",
  "object_manager.bulk-edit-modal.findReplace.findPlaceholder": "Select value(s) to replace",
  "object_manager.bulk-edit-modal.findReplace.replacePlaceholder": "Select new value(s)",
  "object_manager.bulk-edit-modal.findReplace.find-input-label": "Find",
  "object_manager.bulk-edit-modal.findReplace.replace-input-label": "Replace with",
  "object_manager.bulk-edit-modal.add.placeholder": "Select value(s) to add",
  "object_manager.bulk-edit-modal.add.input-placeholder": "Value to add",
  "object_manager.bulk-edit-modal.replaceAll.placeholder": "Select new value(s)",
  "object_manager.bulk-edit-modal.replaceAll.input-placeholder": "New value",
  "object_manager.bulk-edit-modal.removeSpecific.placeholder": "Select value(s) to remove",
  "object_manager.bulk-edit-modal.removeSpecific.input-placeholder": "Value to remove",
  "object_manager.bulk-edit-modal.checkAll.label": "Check all",
  "object_manager.bulk-edit-modal.uncheckAll.label": "Uncheck all",
  "object_manager.bulk-edit-modal.success-message": "Updating objects has started, click on Batch Operations to view the progress",
  "object_manager.bulk-edit-modal.warning.clear": "You are about to clear the value of {0} for {1} objects. This action cannot be undone.",
  "object_manager.bulk-edit-modal.warning.replace-all": "You are about to replace all values of {0} for {1} objects. Existing values will be permanently removed and replaced. This action cannot be undone.",
  "object_manager.bulk-edit-modal.tooltip.no-categories": "There are no categories for this field. Please add categories in Configuration/Fields.",
  "object_manager.bulk-edit-modal.match-rule.match-all": "All",
  "object_manager.bulk-edit-modal.match-rule.match-any": "One",
  "object_manager.bulk-edit-modal.match-rule.label": "Match",
  "object_manager.bulk-edit-modal.match-rule.tooltip": "Match against the whole input",
  "object_manager.bulk-edit-modal.placeholder.search": "Search",
  "object_manager.bulk-delete.button": "Delete",
  "object_manager.bulk-delete.confirm-title": "Delete {0} objects?",
  "object_manager.bulk-delete.confirm-description": "This action cannot be undone.",
  "object_manager.bulk-delete.confirm-ok": "Delete",
  "object_manager.bulk-delete.success": "Delete job started",
  "object_manager.bulk-delete.error": "Failed to start delete job",
  "object_manager.export-modal.checkbox-all": "Select/deselect all",
  "object_manager.export-modal.title": "Export {0} items",
  "object_manager.export-modal.ok-text": "Export",
  "object_manager.export-modal.object-type.tooltip": "The type of object being exported",
  "object_manager.export-modal.id-type.label": "ID type",
  "object_manager.export-modal.id-type.tooltip": "The external ID used to identify the object in the export.",
  "object_manager.export-modal.id-type.external": "External ID",
  "object_manager.export-modal.format.label": "File Format",
  "object_manager.export-modal.format.tooltip": "Choose the export file format. Supported formats: XLSX and CSV.",
  "object_manager.export-modal.format.csv": "CSV (.csv)",
  "object_manager.export-modal.format.xlsx": "Excel (.xlsx)",
  "object_manager.export-modal.separator.label": "Separator",
  "object_manager.export-modal.separator.tooltip": "Character used to separate multiple values within a field (for example: comma or semicolon)",
  "object_manager.export-modal.separator.comma": "Comma (,)",
  "object_manager.export-modal.separator.semicolon": "Semicolon (;)",
  "object_manager.export-modal.separator.pipe": "Pipe (|)",
  "object_manager.export-modal.separator.forward-slash": "Forward slash (/)",
  "object_manager.export-modal.separator.tab": "Tab",
  "object_manager.export-modal.redirect-message": "Export has started, redirecting to job...",
  "object_manager.export-modal.success-message": "Export has started, click on Batch Operations to view the progress",
  "object_manager.export-modal.fields.label": "Select fields to include",
  "object_manager.export-modal.object.id": "Internal ID",
  "object_manager.export-modal.object.ext-id": "Ext. ID",
  "object_manager.export-modal.subtypes-warning": "You have selected an object type that contains child types. Fields and associations that are unique for the child types will not be part of the export",
  "object_manager.export-modal.same-sheet": "Same",
  "object_manager.export-modal.separate-sheet": "Separate",
  "object_manager.export-modal.separate-sheet-type": "Sheet type",
  "object_manager.export-modal.separate-sheets-info": "Export associations in separate sheets, only available for XLSX.",
  "object_manager.bulk-edit-modal.tooltip.field-not-editable": "This field is not configured to be editable. Please check your field configuration.",
  "object_manager.export-modal.associations.label": "Select associations to include",
  "object_manager.export-modal.attributes.label": "Select general info to include",
  "availability_collection.reservation_mapping.title": "Reservation Mapping",
  "availability_collection.reservation_mapping.reservation_mode_select": "Availability Mode",
  "availability_collection.reservation_mapping.reservation_template_select": "Availability Template",
  "availability_collection.reservation_mapping.availability_type": "Availability Type",
  "availability_collection.timeslot.title": "Timeslot",
  "availability_collection.timeslot.delete": "Are you sure you want to delete this timeslot?",
  "availability_collection.period.title": "Availability Period",
  "availability_collection.period.delete": "Are you sure you want to delete this period?",
  "object_generation": "Group Generation",
  "object_generation_title": "Group generation templates",
  "object_generation_subtitle": "Create and manage templates for generating Group objects for Activities",
  "conflict_model": "Conflict Model",
  "activity_template": "Import Template",
  "import_template_expl": "This group generation configuration will be used for all Activities imported or created using the selected Import Template",
  "group_creation_memberships_explanation": "Select the memberships that should be created:",
  "group_creation_relations_explanation": "Select the relations that should be created:",
  "group_creation_missing_memb_or_rel": "Some configuration entries could not be loaded. Did you delete them after having enabled them here? That will lead to errors down the road. Please change something, save, and reload. That should solve the issue. Missing config ids: ",
  "group_creation_missing_memb_or_rel_cannot_bel_selected": "In order to be selectable, a config needs to include the currently selected group object type and at least one object type of the current selected Import Template.",
  "CONFLICT_MODEL_PER_TRACK": "One group per track",
  "CONFLICT_MODEL_REUSE_ALL_GROUPS": "Reuse all groups",
  "CONFLICT_MODEL_REUSE_GROUPS_FOR_SAME_ACTIVITY_TYPE": "Reuse groups for same activity type",
  "CONFLICT_MODEL_PER_TRACK_WITH_PARENT_GROUPS": "One group per track - with parent groups",
  "CONFLICT_MODEL_REUSE_ALL_GROUPS_WITH_PARENT_GROUPS": "Reuse all groups - with parent groups",
  "CONFLICT_MODEL_REUSE_GROUPS_FOR_SAME_ACTIVITY_TYPE_WITH_PARENT_GROUPS": "Reuse groups for same activity type - with parent groups",
  "CONFLICT_MODEL_DESC_PER_TRACK": "Creates one unique group for each track",
  "CONFLICT_MODEL_DESC_REUSE_ALL_GROUPS": "Reuses the groups for all activities with the same amount of tracks",
  "CONFLICT_MODEL_DESC_REUSE_GROUPS_FOR_SAME_ACTIVITY_TYPE": "Reuses the groups for activities with the same activity type and the same amount of tracks",
  "CONFLICT_MODEL_DESC_PER_TRACK_WITH_PARENT_GROUPS": "Creates one unique group for each track, plus a parent group that all of them are members of",
  "CONFLICT_MODEL_DESC_REUSE_ALL_GROUPS_WITH_PARENT_GROUPS": "Reuses the groups for all activities with the same amount of tracks, plus a parent group that all of them are members of",
  "CONFLICT_MODEL_DESC_REUSE_GROUPS_FOR_SAME_ACTIVITY_TYPE_WITH_PARENT_GROUPS": "Reuses the groups for activities with the same activity type and the same amount of tracks, plus a parent group that all of them are members of",
  "group_object_configuration": "Group object configuration",
  "child_groups": "Child groups",
  "parent_groups": "Parent groups",
  "use_same_group_config_as_child_groups": "Use same group config. as child groups",
  "use_same_group_config_as_child_groups_expl": "If yes, the parent groups are created with the same object type, fields, naming, memberships and relations as the child groups",
  "parent_group_missing_membership": "There is no membership configuration between the child group object type and the parent group object type. Parent groups require a membership configuration that has both object types on different levels (also if they are the same object type).",
  "group_creation_organizations_explanation": "Select which organizations the created groups should belong to:",
  "inherit_from_primary_object": "Inherit from primary object",
  "inherit_from_primary_object_expl": "If enabled, the created groups get the organizations of the activity's primary object, in addition to the organizations selected below",
  "group_creation_static_organizations_expl": "The created groups always get these organizations. Only organizations on the lowest level can be selected",
  "template_confirmation_delete": "Are you sure you want to delete this template?",
  "numbering": "Numbering",
  "static_text": "Static Text",
  "object_field_value": "Object Field Value",
  "activity_field_value": "Activity Field Value",
  "select_field_placeholder": "Select value to fill that field with",
  "fill_with": "Fill with",
  "select_field_label": "Select fields to be filled with what data. Please note that we do not check if field types are compatible.",
  "select_object_type_and_field": "Select object type and field",
  "select_object_type_first": "Please select object type first",
  "objects_type_on_activity_template": "Select an object type which is on the import template. If there are multiple objects with same type on activity, we take the first one (maybe).",
  "select_field_on_object": "Select a field on the selected object type",
  "activity_property": "Activity property",
  "activity_group_act_prop_track_number": "Track number",
  "activity_group_to_obj_type_def": "To object type definition",
  "ext_id_expl": "How the external id of the objects is to be constructed. If nothing is configured, a random id will be generated.",
  "group_config_act_change_warn": "Populating the the config to all activities concerned will take a few minutes. If you send activities to activity manager in the meanwhile, it can lead to unpredictable results. It is recommended to wait with sending activities to activity manager until the update is done.",
  "add_field": "Add field",
  "import_settings": "Import settings",
  "validate_file": "Validate file",
  "click_or_drag_file": "Click or drag file to this area to upload",
  "support_single_file_upload": "Support for a single file upload",
  "back": "Back",
  "next": "Next",
  "date_limits": "Date range",
  "defined_date_range": "Use defined date range",
  "defined_date_range_help": "Hard date limits, will be applied after offset is calculated. Start and end are optional, can be left empty.",
  "offset_start": "Start offset",
  "offset_start_help": "Start offset relative now",
  "offset_end": "End offset",
  "offset_end_help": "End offset relative now",
  "unsaved_discard": "You have unsaved changed, do you want to discard?",
  "hub_config_title": "Hub features",
  "hub_config_sub_title": "Manage which features are shown in the Hub.",
  "hub_features_title": "Features in the Hub",
  "default_name": "Feature",
  "feature_status": "Feature status",
  "feature_status_help": "Enable to use this feature",
  "general_information": "General information",
  "preview_import_file_info": "Preview of your import file. Please check that everything looks as intended. Note that not all objects are shown here — only the first 50 rows are displayed for review. Additional sheets in your file will not be included.",
  "alternative_title": "Alternative title",
  "hub_activity_info": "If the setting for \"Name\" does not apply, \"Alternative title\" will be used instead.",
  "suites.curriculum": "Curriculum",
  "suites.workload": "Workload",
  "suites.scheduling": "Scheduling",
  "suites.engagement": "Engagement",
  "suites.insights": "Insights",
  "suites.platform": "Platform"
}
